import { SecurityGuard } from "@duosoftbg/nacid-components";
import ServiceConfigWrapperPage from "../views/pages/ServiceConfigWrapperPage";
import { regprofAdditionalDocServiceConfig } from "../config/servicesConfig";
import React from "react";
import ServiceInfoPage from "../views/pages/ServiceInfoPage";
import RegprofAdditionalDocNewPage from "../views/pages/additionalDoc/RegprofAdditionalDocNewPage";

export const regprofAdditionalDocRoutes = [
  {
    path: "/regprof-additional-doc",
    element: (
      <SecurityGuard doCheck={false}>
        <ServiceConfigWrapperPage serviceConfig={regprofAdditionalDocServiceConfig} wrappedPage={<ServiceInfoPage />} />
      </SecurityGuard>
    ),
  },
  {
    path: "/regprof-additional-doc/new",
    element: (
      <SecurityGuard loginOnUnauthorized={true}>
        <ServiceConfigWrapperPage
          serviceConfig={regprofAdditionalDocServiceConfig}
          wrappedPage={<RegprofAdditionalDocNewPage />}
        />
      </SecurityGuard>
    ),
  },
];
